import { WebToTextConstants } from '@/constants/webtotext-constants'

export { WebToTextConstants }
export const RECAPTCHA_SERVICE_NAME = 'web2text'
export const RECAPTCHA_SITE_KEY = window.Cypress ? Cypress.env('VUE_APP_RECAPTCHA_SITE_KEY') : process.env.VUE_APP_RECAPTCHA_SITE_KEY

export const GA_ID = window.Cypress ? Cypress.env('VUE_APP_GA_ID') : process.env.VUE_APP_GA_ID
export const GA4_ID = window.Cypress ? Cypress.env('VUE_APP_GA4_ID') : process.env.VUE_APP_GA4_ID
export const GA4_PREFIX = 'G-'

export const UA_TO_GA4_ACTION_MAPPING = {
  'widget-open': 'multi_channel_open',
  'custom-widget-settings': 'api_error_settings',
  'form-input': 'form_input',
  'form-input-error': 'form_input_error',
  'form-submit': 'form_submit',
  'recaptcha-failed': 'recaptcha_failed',
  'api-error': 'api_error',
  close: 'close_dialog',
  'open-form': 'open_form',
  'chat-button': 'chat_button'
}
